import React from "react";
import { Button, Spinner } from "react-bootstrap";

const CustomButton = ({
    onClick,
    label,
    loadingLabel = "Loading...",
    status = "idle",
    disabled = false,
    variant = "primary",
    size = "sm",
    className = "",
    ...props
}) => {
    const isLoading = status === "loading";

    return (
        <Button
            variant={variant}
            size={size}
            onClick={onClick}
            disabled={isLoading || disabled}
            className={className}
            {...props}
        >
            {isLoading ? (
                <>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                    />
                    {loadingLabel}
                </>
            ) : (
                label
            )}
        </Button>
    );
};

export default CustomButton;
